import { createFileRoute, redirect } from "@tanstack/react-router";

// /history is now part of /account. Server-redirect inbound traffic + client-side
// fallback for SPA navigation.
export const Route = createFileRoute("/history")({
  server: {
    handlers: {
      GET: async () => new Response(null, { status: 301, headers: { Location: "/account" } }),
    },
  },
  beforeLoad: () => {
    throw redirect({ to: "/account" });
  },
});
